<template>
  <v-card class="card-container">
    <v-dialog v-model="aboutDialog" max-width="800px">
      <AboutTask :receivedLabor="currentLabor" :key="dialogKey" />
    </v-dialog>

    <v-dialog v-model="printDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="success"
          dark
        >
          <div class="text--lighten-1 text-body-2 mb-4">
            <v-icon class="mr-5">mdi-printer-check</v-icon>
            {{ $t('Imprimindo') }}
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este contrato?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteManyDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t('Tem certeza de que deseja excluir as tarefas selecionadas?')
            }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteManyDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="removeMany"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="900px">
      <ManageTask
        title="Editar tarefa"
        :labor="currentLabor"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../../assets/figmaIcons/white/tasks.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{ $t('Tarefas') }}</span>

      <v-spacer></v-spacer>

      <v-btn
        v-show="userType < 4 || userType >= 7"
        color="#0F3565"
        dark
        depressed
        class="hidden-sm-and-down primary-button"
        @click="addTask"
      >
        {{ $t('Nova tarefa') }}
      </v-btn>
      <v-btn
        v-show="buttonDeleteVisible"
        v-if="userType < 3 || userType == 8"
        class="ml-2 hidden-sm-and-down quaternary-button"
        color="#A42A2AD9"
        dark
        depressed
        @click="deleteManyTasks"
      >
        {{ $t('Remover selecionados') }}
      </v-btn>
      <v-btn
        class="ml-3 hidden-sm-and-down secondary-button"
        color="#BBCF20"
        dark
        depressed
        @click="visible = !visible"
      >
        {{ $t('Filtros') }}
      </v-btn>
    </div>

    <div class="my-5 back hidden-md-and-up">
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          v-show="userType < 4 || userType >= 7"
          small
          class="hidden-md-and-up mr-2"
          color="#0F3565"
          dark
          depressed
          @click="addTask"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-show="buttonDeleteVisible"
          v-if="userType < 3 || userType == 8"
          small
          depressed
          class="hidden-md-and-up mr-2"
          color="#A42A2AD9"
          dark
          @click="deleteManyTasks"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="900px">
          <ManageTask
            title="Nova tarefa"
            @close="closeDialog"
            :key="dialogKey"
          />
        </v-dialog>

        <v-btn
          class="hidden-md-and-up"
          small
          depressed
          color="#BBCF20"
          dark
          @click="visible = !visible"
        >
          <v-icon> mdi-filter </v-icon>
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="visible">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="institutionId"
              :items="institutions"
              item-text="name"
              item-value="id"
              :loading="institutionLoading"
              @change="getUnidades"
              outlined
              disabled
              append-icon=""
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="unidadeId"
              :items="unidades"
              item-text="name"
              item-value="id"
              :loading="unidadeLoading"
              :disabled="!institutionId"
              :readonly="institution.userType > 1"
              :placeholder="
                !institutionId ? $t('Selecione uma instituição') : ''
              "
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="label">{{ $t('Setor') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="departmentId"
              :items="departments"
              item-value="id"
              item-text="name"
              :loading="departmentLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:item="{ item }">
                <span class="text-caption" v-if="item.unidade">
                  {{ item.name }} / {{ item.unidade.name }}
                </span>
                <span class="text-caption" v-else>
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Tipo tarefa') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="laborType"
              :items="laborTypes"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:selection="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Nº tarefa') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="laborNumber"
              name="nameLabor"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Estado tarefa') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="laborStatus"
              :items="laborsStatus"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Responsável') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="userId"
              :items="users"
              item-value="id"
              item-text="name"
              :loading="userLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-row class="ma-0" no-gutters>
              <v-col cols="12" class="d-flex justify-center">
                <label class="label">{{ $t('Data inicial') }}</label>
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="menuLaborInitialDate"
                  v-model="menuLaborInitialDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      v-model="initialDate"
                      placeholder="Inicial"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="laborInitialDate = parseDate(initialDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input mr-1"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="laborInitialDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="menuLaborEndDate"
                  v-model="menuLaborEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      :disabled="!initialDate"
                      v-model="endDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      placeholder="Final"
                      @blur="laborEndDate = parseDate(endDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="laborEndDate"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn
              class="mr-1 secondary-button"
              color="#BBCF20"
              @click="filterTable"
              depressed
            >
              <span>{{ $t('Filtrar') }}</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              class="clear-button mr-0"
              color="#20202066"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :headers="headersMobile"
        :items="labors"
        v-model="laborsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.name`]="{ item }">
          {{ item.name != null ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.user`]="{ item }">
          {{ item.requester != null ? item.requester : $t('Sem registro') }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#f5f5f5"
                style="font-weight: bold"
                dark
                @click="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon small color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                depressed
                :color="
                  item.documents && item.documents.length > 0
                    ? '#BBCF20'
                    : '#F5F5F5'
                "
                dark
                @click.stop="uploadDocument(item)"
                v-bind="attrs"
                v-on="on"
                x-small
              >
                <span style="font-size: 0.9rem">
                  {{
                    item.documents && item.documents.length > 0
                      ? item.documents && item.documents.length
                      : ''
                  }}
                </span>
                <v-icon
                  small
                  :class="
                    item.documents && item.documents.length > 0 ? 'ml-1' : ''
                  "
                  :color="
                    item.documents && item.documents.length > 0
                      ? '#fff'
                      : '#BBCF20'
                  "
                >
                  mdi-file-document-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Documentos anexados</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Nº tarefa') }}:</strong>
                {{ String(item.number).padStart(5, '0') }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Tipo') }}:</strong>
                {{ $t(laborTypes[item.eLaborType]) }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Abertura') }}:</strong>
                {{
                  item.laborDate != null
                    ? formatDate(item.laborDate)
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Fechamento') }}:</strong>
                {{
                  item.closeDate != null
                    ? formatDate(item.closeDate)
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Ações') }}: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      :disabled="
                        item.eLaborStatus === 1 &&
                        (userType == 2 || userType == 6)
                      "
                      v-show="userType < 4 || userType >= 7"
                      class="ma-1"
                      color="#0F3565"
                      @click="editTask(item)"
                      v-bind="attrs"
                      v-on="on"
                      small
                      depressed
                    >
                      <v-icon small> mdi-pencil-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Editar') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      color="#F5F5F5"
                      dark
                      @click="generatePDF(item)"
                      v-bind="attrs"
                      v-on="on"
                      small
                      depressed
                    >
                      <v-icon color="#0F3565"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Imprimir') }}</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selecionados: {{ laborsSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="labors"
        v-model="laborsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="pageSize"
        :item-class="isInactive"
        @click:row="editTask"
        @update:options="handleSortUpdate"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          {{ item.name != '' ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.number`]="{ item }">
          {{ String(item.number).padStart(5, '0') }}
        </template>

        <template #[`item.type`]="{ item }">
          {{ $t(laborTypes[item.eLaborType]) }}
        </template>

        <template #[`item.requester`]="{ item }">
          {{ item.requester != null ? item.requester : $t('Sem registro') }}
        </template>

        <template #[`item.openDate`]="{ item }">
          {{
            item.laborDate != null
              ? formatDate(item.laborDate)
              : $t('Sem registro')
          }}
        </template>

        <template #[`item.closeDate`]="{ item }">
          {{
            item.closeDate != null
              ? formatDate(item.closeDate)
              : $t('Sem registro')
          }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="item.eLaborStatus === 1 && userType == 2"
                v-show="userType < 4 || userType >= 7"
                class="ma-1"
                color="#0F3565"
                dark
                @click.stop="editTask(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
              >
                <v-icon small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#f5f5f5"
                style="font-weight: bold"
                dark
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                depressed
                :color="
                  item.documents && item.documents.length > 0
                    ? '#BBCF20'
                    : '#F5F5F5'
                "
                dark
                @click.stop="uploadDocument(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <span style="font-size: 0.9rem">
                  {{
                    item.documents && item.documents.length > 0
                      ? item.documents.length
                      : ''
                  }}
                </span>
                <v-icon
                  small
                  :class="
                    item.documents && item.documents.length > 0 ? 'ml-1' : ''
                  "
                  :color="
                    item.documents && item.documents.length > 0
                      ? '#fff'
                      : '#BBCF20'
                  "
                >
                  mdi-file-document-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Documentos anexados</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                color="#F5F5F5"
                dark
                @click.stop="generatePDF(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
              >
                <v-icon color="#0F3565"> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Imprimir') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selecionados: {{ laborsSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.mobile {
  display: none;
  @media (max-width: 960px) {
    display: block;
  }
}
.desktop {
  @media (max-width: 960px) {
    display: none;
  }
}
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-picker.v-card
  >>> .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: #ffffff;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import AboutTask from './AboutTask.vue'
import ManageTask from './ManageTask.vue'
import Utils from '../../../../Utils/FormatDate'

export default {
  data: () => ({
    institution: {},
    totalItensOnPage: 0,
    visible: false,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    printDialog: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    userLoading: false,
    departmentLoading: false,
    buttonDeleteVisible: false,
    menuLaborInitialDate: false,
    menuLaborEndDate: false,
    userId: null,
    users: [],
    userLogged: {},
    userType: null,
    departmentId: null,
    departments: [],
    unidadeId: null,
    unidades: [],
    institutionId: null,
    institutions: [],
    labors: [],
    laborsSelected: [],
    expanded: [],
    laborTypes: [
      'Validação de equipamentos',
      'Treinamento',
      'Serviço administrativo',
      'Rotina de inspeção',
      'Serviço Operacional',
    ],
    laborsStatus: ['Aberta', 'Fechada'],
    currentLabor: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      number: null,
      userId: null,
      departmentId: null,
      unidadeId: null,
      institutionId: null,
      laborType: null,
      laborStatus: null,
      laborInitialDate: null,
      laborEndDate: null,
      ordination: null,
    },
    laborName: null,
    laborNumber: null,
    laborType: null,
    laborStatus: null,
    laborInitialDate: null,
    laborEndDate: null,
    laborCloseDate: null,
    initialDate: null,
    endDate: null,
    minDate: null,
    headers: [
      {
        text: 'Tarefa',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Nº tarefa',
        align: 'center',
        value: 'number',
      },
      {
        text: 'Tipo',
        align: 'center',
        value: 'type',
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'requester',
      },
      {
        text: 'Abertura',
        align: 'center',
        value: 'openDate',
      },
      {
        text: 'Fechamento',
        align: 'center',
        value: 'closeDate',
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Tarefa',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'user',
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    institution: {},
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userType = this.institution.userType

    this.getInstitutions()
    this.getUsers()
    this.getDepartments()
    this.getUnidades()

    if (this.userType > 2 && this.userType != 8) {
      this.unidadeId = this.userLogged.unidadeId
    }

    this.updateTable()
  },

  components: {
    ManageTask,
    AboutTask,
  },

  methods: {
    uploadDocument(labor) {
      sessionStorage.clear()

      const lab = {
        id: labor.id,
        number: labor.number,
      }
      sessionStorage.setItem('labor', JSON.stringify(lab))

      let routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    addTask() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editTask(labor) {
      if (this.userType == 4) return
      this.currentLabor = labor
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteTask(labor) {
      this.currentLabor = labor
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManyTasks() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    openAbout(labor) {
      this.currentLabor = labor
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    isInactive(value) {
      return value.department.status == 1 ? 'departmentInactive' : ''
    },

    handleSortUpdate({ sortBy, sortDesc }) {
      if (sortBy[0] == 'number' && !sortDesc[0]) {
        this.filter.ordination = 0
      } else if (sortBy[0] == 'number' && sortDesc[0]) {
        this.filter.ordination = 1
      }
      this.updateTable()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.laborName
      this.filter.number = this.laborNumber
      this.filter.userId = this.userId
      this.filter.departmentId = this.departmentId
      this.filter.laborType = this.laborTypes.indexOf(this.laborType)
      this.filter.laborStatus = this.laborsStatus.indexOf(this.laborStatus)
      this.filter.laborInitialDate = this.laborInitialDate
      this.filter.laborEndDate = this.laborEndDate

      this.updateTable()
    },

    reset() {
      this.laborName = null
      this.laborNumber = null
      this.laborType = -1
      this.laborStatus = -1
      this.laborInitialDate = null
      this.laborEndDate = null
      this.laborCloseDate = null
      this.initialDate = null
      this.endDate = null
      this.userId = null
      this.departmentId = null
      this.unidadeId = null
      this.filter = {
        page: 1,
        pageSize: 10,
        name: null,
        number: null,
        userId: null,
        departmentId: null,
        unidadeId: null,
        laborType: null,
        laborStatus: null,
        laborInitialDate: null,
        laborEndDate: null,
      }
      this.updateTable()
    },

    userName(value) {
      const user = this.users.find((user) => user.id === value)

      if (user) {
        return user.name
      }

      return $t('Sem registro')
    },

    async updateTable() {
      this.loading = true

      this.filter.unidadeId = this.unidadeId
      this.filter.institutionId = this.institutionId

      await this.apiService.post('labor/list', this.filter).then((response) => {
        this.totalPages = response.content.pager.totalPages
        this.labors = response.content.labors
        this.totalItensOnPage = response.content.labors.length
        this.totalItems = response.content.pager.totalItems
        this.loading = false
      })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('labor/delete', this.currentLabor)
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.updateTable()
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('labor/deleteMany', this.laborsSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.contractsSelected = []
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async generatePDF(labor) {
      this.printDialog = true
      this.apiService
        .get(`labor/printlabor/${labor.id}`)
        .then((response) => {
          var w = window.open('')
          w.document.write(response.content.html)

          var pedfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute(
            'download',
            `Tarefa:${labor.id}_${this.formatDate(labor.laborDate)}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch(() => {})
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.initialDate = this.formatInputDate(this.laborInitialDate)
      this.$refs.menuLaborInitialDate.save(date)
      this.minDate = new Date(this.laborInitialDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.laborEndDate)
      this.$refs.menuLaborEndDate.save(date)
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    laborsSelected() {
      this.buttonDeleteVisible = this.laborsSelected.length > 0
    },
  },
}
</script>
